import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    onClick() {
        window.location.href = '/';
    }
    mounted() {
        setTimeout(() => { window.location.href = '/'; }, 3000);
    }
};
default_1 = __decorate([
    Component({
        name: 'Error',
        i18n: {
            messages: {
                'en-us': {
                    error: 'Error',
                    refresh: 'Refresh Website'
                },
                zh: {
                    refresh: ' 刷新站点',
                    error: '无法访问',
                },
            },
        },
    })
], default_1);
export default default_1;
